export const routes = {
  example: 'example',
  auth: {
    auth_url: '/Auth/v1.0/auth-url',
    get_tokens: '/Auth/v1.0/tokens',
    logout: '/Auth/v1.0/logout',
    verify_token: '/Auth/v1.0/verify-token',
    refresh_token: '/Auth/v1.0/refresh-token',
  },
  user: {
    add_user: '/User/v1.0/',
    get_users: '/User/v1.0',
  },
  backend: {
    user: {
      create: '/User/v1.0/add-user',
      getUserByUserId: '/User/v1.0/',
    },
    estate: {
      add: '/Estate/v1.0/',
      all: '/Estate/v1.0/',
    },
    lot: {
      base: '/Lot/v1.0/',
      getAllLots: '/Lot/v1.0/lots/all',
      pre_process_update: '/Lot/v1.0/pre-process/',
      insertOrUpdateLotProcessStep: `/Lot/v1.0/process/`,
      insertOrUpdateSingleLotProcessStage: lotId => `/Lot/v1.0/process/${lotId}/step/`,
      updateSingleLotProcessStage: lotId => `/Lot/v1.0/process/${lotId}/step/update/`,
      insertOrUpdateFermentationProcessCheck: (lotId, processStepId) =>
        `/Lot/v1.0/process/${lotId}/step/${processStepId}/check/`,
      endFermentation: (lotId, processStepId) =>
        `/Lot/v1.0/process/${lotId}/step/${processStepId}/complete-fermentation/`,
      addOrDeleteProcessStep: lotId => `/Lot/v1.0/process/${lotId}/step/`,
      // move to drying
      changeLotStage: lotId => `/Lot/v1.0/${lotId}/stage/`,
      updatePreProcessData: id => `/Lot/v1.0/lot/pre-process/${id}/update`,
    },
    drying_stage: {
      get_drying_bed_info_by_bed_position: '/DryingBedsMaster/v1.0/get-drying-bed-info-by-bed-number-position',
      get_drying_lots_with_active_beds: 'DryingLot/v1.0/lots-with-days-and-bed-count',
      get_drying_beds_of_lot: lotId => `DryingLot/v1.0/drying-lots/${lotId}`,
      start_drying: lotId => `DryingLot/v1.0/create-drying-lot/${lotId}`,
      get_drying_bed_checks: dryingLotId => `DryingLot/v1.0/drying-checks/${dryingLotId}`,
      add_drying_check: `DryingLot/v1.0/add-drying-check`,
      update_drying_check: `DryingLot/v1.0/update-drying-check`,
      get_drying_bed_info: id => `DryingLot/v1.0/drying-bed-info/${id}`,
      add_drying_bed_to_existing_lot: `/DryingLot/v1.0/add-drying-bed`,
      end_drying_on_bed: id => `DryingLot/v1.0/end-drying-on-bed/${id}`,
      end_drying: 'DryingLot/v1.0/end-drying/',
    },
    storage_lot: {
      get_storage_lots: '/StorageLot/v1.0/',
      create_storage_lot: '/StorageLot/v1.0/create',
      update_storage_lot: id => `/StorageLot/v1.0/update/${id}`,
      get_storage_lot_by_id: id => `/StorageLot/v1.0/all/${id}`,
      get_storage_consumptions: id => `/StorageLot/v1.0/consumptions/${id}`,
      create_storage_consumption: '/StorageLot/v1.0/consumption/create',
      update_storage_consumption: id => `/StorageLot/v1.0/consumption/update/${id}`,
    },
    uploads: {
      getSignedUrls: '/Upload/v1.0/signed-upload-urls',
      deleteMedia: '/Upload/v1.0/delete-files',
    },
    masterTable: {
      varietalList: '/VarietalMaster/v1.0',
      agentList: '/AgentMaster/v1.0',
      dryingBeds: '/DryingBedsMaster/v1.0/get-drying-beds',
    },
  },
};
